export default __webpack_public_path__ + "2445205b4012cb7ef249ba8ab57821e4.png";